import { z } from 'zod';
/**
 * Einheitliches Fehlerformat der API: `{ "error": { "code", "message", "fields"? } }` (PLAN.md T19).
 * `fields` enthält bei Validierungsfehlern je Feld einen Fehlercode (z. B. `password: "too_short"`).
 */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        fields: z.record(z.string(), z.string()).optional(),
    }),
});
//# sourceMappingURL=error.js.map